import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import copy from "copy-text-to-clipboard";
import { useTranslation } from "react-i18next";

import { theme } from "../../constants";
import { components } from "../../components";
import { APP_ROUTES } from "../../constants/app_routes";
import { TRANSLATE } from "../../i18n/translation";
import ProfileMenuItem from "../../components/profile/ProfileMenuItem";
import {
  AvatarIcon,
  BalanceHistoryIcon,
  CopyIcon,
  LogoutIcon,
  MailIcon,
  PersonalIcon,
  Setting2Icon,
  TranslateIcon,
} from "../../constants/icons";
import AuthLayout from "../../services/auth/jwt/withAuth";
import { useQueryProfile } from "../../graphql/apollo/useQuery";
import { useAuthMethod } from "../../hooks/useAuth";
import { RiVipCrownLine } from "react-icons/ri";
import { colors } from "../../constants/colors";

export const ProfileScreen: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { logout } = useAuthMethod();

  const { myProfile } = useQueryProfile();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);

  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };

  const handleLogout = () => logout();

  return (
    <AuthLayout>
      <main className="container profile">
        <div className="profile__header">
          <div className="profile__header_avatar">
            {myProfile?.avatar ? (
              <div>
                <img src={myProfile?.avatar?.url} alt="avatar" />
              </div>
            ) : (
              <AvatarIcon size={50} color="white" />
            )}
          </div>
          {myProfile?.memberStatus && (
            <div className="profile__header_vip">
              <RiVipCrownLine size={40} color={colors.accentColor} />
              <h6
                style={{
                  color: colors.accentColor,
                  textAlign: "center",
                  marginTop: 0,
                  paddingTop: 0,
                  lineHeight: 0.8,
                }}
              >
                VIP
              </h6>
            </div>
          )}
          <div className="profile__header_id">
            <h6>
              {t("userId")}: #{myProfile?.memberId}
            </h6>
            <CopyIcon
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                marginLeft: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                copy(myProfile?.memberId);
              }}
            />
          </div>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Link to={APP_ROUTES.SUPPORT}>
                <Button variant="contained" fullWidth color="warning">
                  <span className="text-white">{t(TRANSLATE.DEPOSIT)}</span>
                </Button>
              </Link>
            </Grid>
            <Grid item xs={6}>
              <Link to={APP_ROUTES.WITHDRAW}>
                <div className="d-grid gap-2">
                  <Button
                    variant="contained"
                    fullWidth
                    color="inherit"
                    sx={{ background: "#262c3c", color: "white" }}
                  >
                    <span className="text-white">{t(TRANSLATE.WITHDRAW)}</span>
                  </Button>
                </div>
              </Link>
            </Grid>
          </Grid>
        </div>
        <div className="profile__menu">
          <p className="profile__menu-title">{t("general")}</p>
          <ProfileMenuItem
            title={t("emailOrPhone")}
            rightText={myProfile?.email}
            icon={<MailIcon className="profile-icon" color="green" />}
            showRightIcon={false}
          />
          <p className="profile__menu-title">{t("other")}</p>
          <ProfileMenuItem
            to={APP_ROUTES.PERSONAL}
            title={t("personalData")}
            icon={
              <PersonalIcon
                className="profile-icon"
                color={theme.colors.darkGrey}
              />
            }
          />
          <ProfileMenuItem
            to={APP_ROUTES.TRANSACTIONS}
            title={t("fundDetail")}
            icon={
              <BalanceHistoryIcon
                className="profile-icon"
                color={theme.colors.darkGrey}
              />
            }
          />
          <ProfileMenuItem
            to={APP_ROUTES.SETTINGS}
            title={t("setting")}
            icon={
              <Setting2Icon
                className="profile-icon"
                color={theme.colors.darkGrey}
              />
            }
          />
          <ProfileMenuItem
            to={APP_ROUTES.LANGUAGE}
            title={t("language")}
            icon={
              <TranslateIcon
                className="profile-icon"
                color={theme.colors.darkGrey}
              />
            }
          />
          <ProfileMenuItem
            showBullet={true}
            title={t("logout")}
            icon={
              <LogoutIcon
                className="profile-icon"
                color={theme.colors.darkGrey}
              />
            }
            onClick={handleLogout}
          />
        </div>
      </main>
      {renderBottomTabBar()}
    </AuthLayout>
  );
};
